// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
const twitter_url = 'https://twitter.com/intent/tweet';
const facebook_url = 'https://www.facebook.com/sharer/sharer.php';
const linkedin_url = 'https://www.linkedin.com/shareArticle';

interface i_share_props {
    article_id: string;
    article_title: string;
}

export const use_article_links = (props:i_share_props)=>{
    // XXX dmitriiz: ssr doesn't support location.protocol today
    const permalink = `https://hola.org`+
        `/blog/article/id/${props.article_id}`;
    const twitter_link = `${twitter_url}?${new window.URLSearchParams({
        text: props.article_title,
        via: 'Hola',
        url: permalink,
    })}`;
    const facebook_link = `${facebook_url}?${new window.URLSearchParams({
        u: permalink,
    })}`;
    const linkedin_link = `${linkedin_url}?${new window.URLSearchParams({
        mini: 'true',
        url: permalink,
        title: props.article_title,
    })}`;
    const copy = ()=>{
        void navigator.clipboard.writeText(permalink)
            .then(()=>alert(`Copied!`));
    };
    return {permalink, facebook_link, twitter_link, linkedin_link, copy};
};
